module.exports = __webpack_public_path__ + "static/media/postgre.2c3e4ef4.png";